// Legacy from when we used Mocktail
import { connect } from 'react-redux'
export default connect
